<template>
    <Teleport to="body">
        <div class="work-time-modal-backdrop" v-if="modelValue">
            <div class="work-time-modal">
                <div class="work-time-modal-head">
                    <div class="work-time-head-left">
                        <div class="work-time-head-icon">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path d="M8 2v3M16 2v3M3.5 9h17M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                <path d="M12 13v3l2 1.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>

                        <div>
                            <h4>Haftalık Çalışma Süresi Ekle</h4>
                            <span>Haftalık çalışma sürelerini görüntüle ve güncelle.</span>
                        </div> 
                    </div>

                    <button type="button" class="work-time-close" @click="close">×</button>
                </div>

                <div class="work-time-week-head">

                    <div class="week-title">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <g>
                                <circle cx="8" cy="13.5" r="1"/>
                                <circle cx="8" cy="17.5" r="1"/>
                                <circle cx="12" cy="13.5" r="1"/>
                                <circle cx="12" cy="17.5" r="1"/>
                                <circle cx="16" cy="13.5" r="1"/>
                                <circle cx="16" cy="17.5" r="1"/>
                                <path d="m22.75 6.5v13c0 .995-.395 1.948-1.098 2.652-.704.703-1.657 1.098-2.652 1.098h-14c-.995 0-1.948-.395-2.652-1.098-.703-.704-1.098-1.657-1.098-2.652v-13c0-.995.395-1.948 1.098-2.652.704-.703 1.657-1.098 2.652-1.098h14c.995 0 1.948.395 2.652 1.098.703.704 1.098 1.657 1.098 2.652zm-1.5 0c0-.597-.237-1.169-.659-1.591s-.994-.659-1.591-.659h-14c-.597 0-1.169.237-1.591.659s-.659.994-.659 1.591v13c0 .597.237 1.169.659 1.591s.994.659 1.591.659h14c.597 0 1.169-.237 1.591-.659s.659-.994.659-1.591z"/>
                                <path d="m22 8.25c.414 0 .75.336.75.75s-.336.75-.75.75h-20c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z"/>
                                <path d="m15.25 1.5c0-.414.336-.75.75-.75s.75.336.75.75v4c0 .414-.336.75-.75.75s-.75-.336-.75-.75z"/>
                                <path d="m7.25 1.5c0-.414.336-.75.75-.75s.75.336.75.75v4c0 .414-.336.75-.75.75s-.75-.336-.75-.75z"/>
                            </g>
                        </svg>

                        <strong>{{ weekRangeTitle }}</strong>
                    </div>
                    
                </div>

                <div class="work-time-week-days">
                    <button
                        v-for="day in weekDays"
                        :key="dateKey(day.date)"
                        type="button"
                        class="week-day-item"
                        :disabled="isFutureDay(day.date)"
                        :class="{
                            active: D.DateEqual(day.date, localDate),
                            filled: getMinuteByDate(day.date) > 0,
                            disabled: isFutureDay(day.date)
                        }"
                        @click="selectDay(day.date)"
                    >
                        <span>{{ day.dayName }}</span>
                        <strong>{{ day.dayNumber }}</strong>
                    </button>
                </div>

                <div class="work-time-entry-card">
                    <div class="entry-left">
                        <label>{{ selectedDayName }} için çalışma süresi</label>

                        <div class="time-control">
                            <button type="button" @click="decreaseMinute">−</button>

                            <div class="time-value">
                                <strong>{{ formatMinute(localMinute) }}</strong>
                                <span>saat</span>
                            </div>

                            <button type="button" @click="increaseMinute">+</button>
                        </div>
                    </div>

                    <div class="entry-divider"></div>

                    <div class="entry-right">
                        <label>Hızlı Seçim</label>

                        <div class="quick-hour-list">
                            <button
                                v-for="hour in quickHours"
                                :key="hour"
                                type="button"
                                :class="{ active: C.Int(localMinute) === hour * 60 }"
                                @click="setQuickHour(hour)"
                            >
                                {{ hour }}s
                            </button>
                        </div>
                    </div>
                </div>

                <div class="weekly-preview-card">
                    <div class="preview-head">
                        <strong>Haftalık Önizleme</strong>
                        <span>Bu hafta toplam <b>{{ formatMinute(totalMinute) }}</b> saat</span>
                    </div>

                    <div class="preview-chart">
                        <div class="preview-axis">
                            <span>8s</span>
                            <span>4s</span>
                            <span>0s</span>
                        </div>

                        <div class="preview-bars">
                            <div
                                v-for="day in weekDays"
                                :key="'bar-' + dateKey(day.date)"
                                class="preview-bar-item"
                            >
                                <div class="bar-track">
                                    <i :style="{ height: getBarHeight(day.date) + '%' }"></i>
                                </div>

                                <strong>{{ day.dayName }}</strong>
                                <span>{{ getMinuteByDate(day.date) > 0 ? formatMinute(getMinuteByDate(day.date)) : '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="work-time-actions">
                    <button type="button" class="btn-cancel" @click="close">
                        Vazgeç
                    </button>

                    <button type="button" class="btn-save" @click="save">
                        Kaydet {{ totalMinute > 0 ? '(' + formatMinute(totalMinute) + ')' : '' }}
                    </button>
                </div>

            </div>
        </div>
    </Teleport>
</template>

<script>
import { reactive, toRefs, watch, computed, nextTick } from "vue";

import { Enums } from "@/helpers/enums";
import { C, D, J } from "@/helpers/global";
import { Constants } from "@/helpers/constants";

export default {
    name: "WorkTimeModal",

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },

        date: {
            type: [Date, String],
            default: null,
        },

        minute: {
            type: Number,
            default: 0,
        },

        dayMinuteList: {
            type: Array,
            default: () => [],
        },
        weekStartDate: {
            type: [Date, String],
            default: null,
        },

        weekEndDate: {
            type: [Date, String],
            default: null,
        },
    },

    emits: [
        "update:modelValue",
        "save",
    ],

    setup(props, ctx) {
        const e = reactive({
            Enums,
            C,
            D,

            localDate: props.date ? C.Date(props.date) : D.ServerNow(),
            localMinute: C.Int(props.minute),
            quickHours: [2, 4, 6, 8],
            minuteMap: {},

            weekStart: computed(() => {
                return props.weekStartDate
                    ? D.RemoveTime(C.Date(props.weekStartDate))
                    : e.getWeekStart(e.localDate);
            }),

            weekDays: computed(() => {
                return Array.from({ length: 7 }).map((_, index) => {
                    const date = D.DateAdd(Enums.DATE.DAY, index, e.weekStart);

                    return {
                        date,
                        dayNumber: D.GetDay(date),
                        dayName: e.getShortDayName(date),
                    };
                });
            }),

            weekRangeTitle: computed(() => {
                const start = e.weekDays[0]?.date;
                const end = e.weekDays[6]?.date;

                if (!start || !end) {
                    return "";
                }

                const startMonth = J.FindKey(Constants.Date.MonthSortList, D.GetMonth(start));
                const endMonth = J.FindKey(Constants.Date.MonthSortList, D.GetMonth(end));

                if (D.GetMonth(start) === D.GetMonth(end)) {
                    return `${D.GetDay(start)} - ${D.GetDay(end)} ${endMonth} ${end.getFullYear()}`;
                }

                return `${D.GetDay(start)} ${startMonth} - ${D.GetDay(end)} ${endMonth} ${end.getFullYear()}`;
            }),

            selectedDayName: computed(() => {
                return e.getLongDayName(e.localDate);
            }),

            totalMinute: computed(() => {
                return e.weekDays.reduce((total, day) => {
                    return total + e.getMinuteByDate(day.date);
                }, 0);
            }),

            selectedDayCount: computed(() => {
                return e.weekDays.filter(day => e.getMinuteByDate(day.date) > 0).length;
            }),
            isNextWeekDisabled: computed(() => {
                const nextDate = D.DateAdd(Enums.DATE.DAY, 7, e.localDate);
                return e.getWeekStart(nextDate) > e.getWeekStart(D.ServerNow());
            }),

            dateKey(date) {
                const d = new Date(date);

                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");

                return `${year}-${month}-${day}`;
            },

            getWeekStart(date) {
                const d = D.RemoveTime(C.Date(date));
                const dayIndex = (d.getDay() + 6) % 7;

                return D.DateAdd(Enums.DATE.DAY, -dayIndex, d);
            },

            getShortDayName(date) {
                return J.FindKey(Constants.Date.DaySortList, ((C.Date(date).getDay() + 6) % 7) + 1);
            },

            getLongDayName(date) {
                const shortName = e.getShortDayName(date);

                const map = {
                    Pzt: "Pazartesi",
                    Sal: "Salı",
                    Çar: "Çarşamba",
                    Per: "Perşembe",
                    Cum: "Cuma",
                    Cmt: "Cumartesi",
                    Paz: "Pazar",
                };

                return map[shortName] || shortName;
            },

            getMinuteByDate(date) {
                return C.Int(e.minuteMap[e.dateKey(date)]);
            },

            setMinuteByDate(date, minute) {
                const key = e.dateKey(date);
                const value = C.Int(minute);

                if (value > 0) {
                    e.minuteMap[key] = value;
                }
                else {
                    delete e.minuteMap[key];
                }
            },

            initMinuteMap() {
                e.minuteMap = {};

                props.dayMinuteList.forEach((item) => {
                    const dayDate = item.dayDate || item.date || item.day;
                    const minute = C.Int(item.minute || item.count || item.workMinute);

                    if (dayDate && minute > 0) {
                        e.minuteMap[e.dateKey(dayDate)] = minute;
                    }
                });

                if (props.date && C.Int(props.minute) > 0) {
                    e.minuteMap[e.dateKey(props.date)] = C.Int(props.minute);
                }

                e.localMinute = e.getMinuteByDate(e.localDate);
            },

            getInitialDate() {
                const today = D.RemoveTime(D.ServerNow());
                const start = props.weekStartDate ? D.RemoveTime(C.Date(props.weekStartDate)) : e.getWeekStart(today);
                const end = props.weekEndDate ? D.RemoveTime(C.Date(props.weekEndDate)) : D.DateAdd(Enums.DATE.DAY, 6, start);

                if (D.DateMinEqual(start, today) && D.DateMinEqual(today, end)) {
                    return today;
                }

                return start;
            },

            isFutureDay(date) {
                return D.RemoveTime(C.Date(date)) > D.RemoveTime(D.ServerNow());
            },

            selectDay(date) {
                if (e.isFutureDay(date)) {
                    return;
                }

                e.localDate = C.Date(date);
                e.localMinute = e.getMinuteByDate(e.localDate);
            },

            increaseMinute() {
                e.localMinute = Math.min(1200, C.Int(e.localMinute) + 15);
                e.setMinuteByDate(e.localDate, e.localMinute);
            },

            decreaseMinute() {
                e.localMinute = Math.max(0, C.Int(e.localMinute) - 15);
                e.setMinuteByDate(e.localDate, e.localMinute);
            },

            goToday() {
                e.selectDay(D.ServerNow());
            },

            slideWeek(direction) {
                return;
            },

            setQuickHour(hour) {
                e.localMinute = C.Int(hour) * 60;
                e.setMinuteByDate(e.localDate, e.localMinute);
            },

            getBarHeight(date) {
                const minute = e.getMinuteByDate(date);
                if (minute <= 0) {
                    return 0;
                }

                return Math.min(100, Math.round((minute / 480) * 100));
            },

            formatMinute(minute) {
                const value = C.Int(minute);
                const hour = Math.floor(value / 60);
                const min = value % 60;

                return `${hour.toString().padStart(2, "0")}:${min.toString().padStart(2, "0")}`;
            },

            close() {
                ctx.emit("update:modelValue", false);
            },

            save() {
                const dayMinuteList = Object.keys(e.minuteMap).map((key) => ({
                    dayDate: key,
                    minute: C.Int(e.minuteMap[key]),
                }));

                ctx.emit("save", {
                    dayDate: e.dateKey(e.localDate),
                    minute: C.Int(e.localMinute),
                    dayMinuteList,
                });

                e.close();
            },
        });

        watch(() => props.modelValue, (val) => {
            if (val) {
                e.localDate = e.getInitialDate();
                e.initMinuteMap();

                nextTick(() => {
                    e.localMinute = e.getMinuteByDate(e.localDate);
                });
            }
        });

        watch(() => props.date, (val) => {
            if (val) {
                e.localDate = C.Date(val);
                e.localMinute = e.getMinuteByDate(e.localDate);
            }
        });

        watch(() => e.localMinute, (val) => {
            e.setMinuteByDate(e.localDate, val);
        });

        return { ...toRefs(e) };
    },
};
</script>

<style scoped>
.work-time-modal-backdrop {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    background: rgba(34, 24, 55, .38);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
}

.work-time-modal {
    width: 640px;
    max-width: calc(100vw - 28px);
    border-radius: 22px;
    background: #fff;
    padding: 20px;
    box-shadow: 0 26px 70px rgba(43, 30, 71, .20);
    position: relative;
    z-index: 1000000;
}

.work-time-modal-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 14px;
    margin-bottom: 16px;
    border-bottom: 1px solid #edf0f6;
     grid-template-columns: 1fr;
}

.work-time-head-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.work-time-head-icon {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: rgba(164, 90, 203, .1);
    color: #a45acb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 44px;
}

.work-time-head-icon svg {
    width: 25px;
    height: 25px;
}

.work-time-modal-head h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #24193e;
}

.work-time-modal-head span {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #8b7c99;
}

.work-time-close {
    border: 0;
    background: #f5effb;
    color: #8e42d8;
    width: 36px;
    height: 36px;
    border-radius: 12px;
    font-size: 23px;
    line-height: 1;
    font-weight: 600;
}

.work-time-week-head {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 14px;
}

.week-title {
    height: 44px;
    border: 1px solid #e2e7f0;
    border-radius: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    color: #24193e;
    background: #fff;
    min-width: 0;
}

.week-title svg {
    width: 18px;
    height: 18px;
    color: #a45acb;
    flex: 0 0 18px;
}

.week-title strong {
    font-size: 15px;
    font-weight: 700;
}

.today-btn {
    display: none;
}

.week-nav-btn {
    display: none;
}
.week-day-item.disabled {
    opacity: .45;
    cursor: not-allowed;
    background: #f6f7fb;
    border-color: #e6e9f0;
}

.week-day-item.disabled strong,
.week-day-item.disabled span {
    color: #a5acba;
}

.work-time-week-days {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.week-day-item {
    height: 76px;
    border: 1px solid #e2e7f0;
    border-radius: 15px;
    background: #fff;
    color: #24193e;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    transition: .18s ease;
}

.week-day-item span {
    font-size: 13px;
    font-weight: 600;
}

.week-day-item strong {
    font-size: 21px;
    font-weight: 700;
    color: #70788f;
}

.week-day-item.filled {
    border-color: rgba(164, 90, 203, .72);
}

.week-day-item.active {
    border-color: transparent;
    background: linear-gradient(135deg, #b25bd6, #8e42d8);
    color: #fff;
    box-shadow: 0 10px 22px rgba(164, 90, 203, .22);
}

.week-day-item.active strong {
    color: #fff;
}

.work-time-entry-card {
    border: 1px solid #e2e7f0;
    border-radius: 16px;
    padding: 18px;
    display: grid;
    grid-template-columns: 1fr 1px 0.78fr;
    gap: 18px;
    align-items: center;
    margin-bottom: 16px;
}

.entry-left,
.entry-right {
    min-width: 0;
}

.entry-left label,
.entry-right label {
    display: block;
    margin-bottom: 12px;
    font-size: 13px;
    font-weight: 700;
    color: #24193e;
}

.entry-divider {
    width: 1px;
    height: 82px;
    background: #e8edf5;
}

.time-control {
    display: grid;
    grid-template-columns: 48px 1fr 48px;
    align-items: center;
    gap: 14px;
}

.time-control button {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid #b45cdc;
    background: #fff;
    color: #9b45cf;
    font-size: 28px;
    line-height: 1;
    font-weight: 400;
}

.time-value {
    text-align: center;
}

.time-value strong {
    display: block;
    color: #a044d0;
    font-size: 33px;
    line-height: 1;
    font-weight: 700;
}

.time-value span {
    display: block;
    margin-top: 5px;
    color: #7d718c;
    font-size: 12px;
    font-weight: 700;
}

.quick-hour-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}

.quick-hour-list button {
    height: 38px;
    border: 1px solid #e4c9f3;
    border-radius: 11px;
    background: #fff;
    color: #8e42d8;
    font-size: 13px;
    font-weight: 800;
    transition: .18s ease;
}

.quick-hour-list button.active,
.quick-hour-list button:hover {
    background: #8e42d8;
    color: #fff;
    border-color: #8e42d8;
}

.weekly-preview-card {
    border: 1px solid #e2e7f0;
    border-radius: 16px;
    padding: 16px 18px 18px;
    margin-bottom: 16px;
}

.preview-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.preview-head strong {
    font-size: 14px;
    font-weight: 700;
    color: #24193e;
}

.preview-head span {
    font-size: 12px;
    font-weight: 600;
    color: #8b93a7;
}

.preview-head b {
    color: #a044d0;
    font-weight: 900;
}

.preview-chart {
    display: grid;
    grid-template-columns: 34px 1fr;
    gap: 10px;
}

.preview-axis {
    height: 122px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #8b93a7;
    font-size: 11px;
    font-weight: 800;
    padding: 2px 0 25px;
}

.preview-bars {
    height: 122px;
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 12px;
    position: relative;
}

.preview-bars::before,
.preview-bars::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    border-top: 1px dashed #dfe5ef;
    pointer-events: none;
}

.preview-bars::before {
    top: 0;
}

.preview-bars::after {
    top: 50%;
}

.preview-bar-item {
    display: grid;
    grid-template-rows: 1fr auto auto;
    align-items: end;
    text-align: center;
    gap: 5px;
    position: relative;
    z-index: 1;
}

.bar-track {
    height: 78px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.bar-track i {
    width: 28px;
    min-height: 0;
    border-radius: 7px 7px 3px 3px;
    background: linear-gradient(180deg, #c770e0, #8e42d8);
    display: block;
    transition: .18s ease;
}

.preview-bar-item strong {
    font-size: 11px;
    font-weight: 900;
    color: #24193e;
}

.preview-bar-item span {
    font-size: 11px;
    font-weight: 700;
    color: #7d869c;
}

.work-time-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.btn-cancel,
.btn-save {
    height: 48px;
    border-radius: 14px;
    border: 0;
    font-size: 14px;
    font-weight: 700;
}

.btn-cancel {
    background: #f3eef8;
    color: #6f617d;
}

.btn-save {
    background: linear-gradient(135deg, #a94bd1, #8e42d8);
    color: #fff;
    box-shadow: 0 10px 22px rgba(164, 90, 203, .20);
}

.work-time-note {
    margin-top: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #8b93a7;
    font-size: 12px;
    font-weight: 600;
}

.work-time-note span {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    border: 1px solid #a9b1c2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 800;
}

.week-nav-btn:disabled {
    opacity: .35;
    cursor: not-allowed;
    pointer-events: none;
}

@media (max-width: 768px) {
    .work-time-modal-backdrop {
        align-items: center;
        justify-content: center;
        padding: 10px;
        overflow-y: auto;
    }

    .work-time-modal {
        width: 100%;
        border-radius: 20px;
        padding: 14px;
        margin: auto 0;
    }

    .work-time-modal-head {
        padding-bottom: 12px;
        margin-bottom: 12px;
    }

    .work-time-head-left {
        gap: 10px;
    }

    .work-time-head-icon {
        width: 38px;
        height: 38px;
        border-radius: 12px;
        flex: 0 0 38px;
    }

    .work-time-head-icon svg {
        width: 22px;
        height: 22px;
    }

    .work-time-modal-head h4 {
        font-size: 16px;
    }

    .work-time-modal-head span {
        font-size: 10.5px;
        line-height: 1.35;
    }

    .work-time-close {
        width: 34px;
        height: 34px;
        border-radius: 11px;
        font-size: 22px;
    }

    .work-time-week-head {
        grid-template-columns: 1fr;
        gap: 8px;
        margin-bottom: 10px;
    }

    .today-btn {
        display: none;
    }

    .week-title {
        height: 40px;
        border-radius: 12px;
        gap: 7px;
    }

    .week-title strong {
        font-size: 13px;
    }

    .week-title svg {
        width: 16px;
        height: 16px;
    }

    .work-time-week-days {
        gap: 5px;
        margin-bottom: 12px;
    }

    .week-day-item {
        height: 50px;
        border-radius: 10px;
        gap: 0px;
    }

    .week-day-item span {
        font-size: 10px;
    }

    .week-day-item strong {
        font-size: 16px;
    }

    .work-time-entry-card {
        padding: 10px;
        gap: 10px;
        margin-bottom: 12px;
        border-radius: 14px;
        align-items: start;
    }

    .entry-left label,
    .entry-right label {
        margin-bottom: 8px;
        font-size: 12px;
    }

    .time-control {
        grid-template-columns: 40px 1fr 40px;
        gap: 8px;
    }

    .time-control button {
        width: 30px;
        height: 30px;
        font-size: 20px;
    }

    .time-value strong {
        font-size: 22px;
    }

    .time-value span {
        font-size: 11px;margin-top: 0px;
    }
    .entry-divider{
        height: 70px;
    }

    .quick-hour-list {
        grid-template-columns: repeat(4, 1fr);
        gap: 5px;
    }

    .quick-hour-list button {
        height: 40px;
        border-radius: 7px;
        font-size: 12px;
    }

    .weekly-preview-card {
        padding: 12px;
        margin-bottom: 12px;
        border-radius: 14px;
    }

    .preview-head {
        margin-bottom: 10px;
        align-items: center;
        gap: 3px;
    }

    .preview-head strong {
        font-size: 13px;
    }

    .preview-head span {
        font-size: 11px;
    }

    .preview-chart {
        grid-template-columns: 25px 1fr;
        gap: 7px;
    }

    .preview-axis {
        height: 102px;
        font-size: 9px;
        padding: 2px 0 22px;
    }

    .preview-bars {
        height: 102px;
        gap: 5px;
    }

    .bar-track {
        height: 64px;
    }

    .bar-track i {
        width: 20px;
        border-radius: 6px 6px 3px 3px;
    }

    .preview-bar-item {
        gap: 4px;
    }

    .preview-bar-item strong,
    .preview-bar-item span {
        font-size: 9.5px;
    }

    .work-time-actions {
        gap: 9px;
    }

    .btn-cancel,
    .btn-save {
        height: 42px;
        border-radius: 12px;
        font-size: 13px;
    }

    .work-time-note {
        margin-top: 10px;
        font-size: 10.5px;
        text-align: center;
    }
}
</style>